// lib/list/listReferenceContinuation.ts
import type { ListReferenceContinuation } from '#types/types';
import { listOutputMentionIds } from './listOutputMentions';

export async function waitForListMessagePersistence(pending: Promise<void> | undefined, signal: AbortSignal): Promise<void> {
  signal.throwIfAborted();
  if (!pending) return;
  await new Promise<void>((resolve, reject) => {
    const onAbort = () => { signal.removeEventListener('abort', onAbort); reject(signal.reason); };
    signal.addEventListener('abort', onAbort, { once: true });
    pending.then(() => { signal.removeEventListener('abort', onAbort); resolve(); }, error => { signal.removeEventListener('abort', onAbort); reject(error); });
  });
}

export function listContinuationBrief(
  handoff: Partial<ListReferenceContinuation>,
  scope: { projectId: string; sessionId: string; userId: string; currentPrompt: string; rootTimestamp: string },
): string {
  const previousOutputs = typeof handoff.previousPrompt === 'string' ? listOutputMentionIds(handoff.previousPrompt) : [];
  if (handoff.projectId !== scope.projectId || handoff.sessionId !== scope.sessionId || handoff.userId !== scope.userId
    || handoff.currentPrompt !== scope.currentPrompt || handoff.rootTimestamp !== scope.rootTimestamp
    || !handoff.userMessageId || !handoff.rootUserMessageId || handoff.userMessageId === handoff.rootUserMessageId
    || !handoff.outputId || !/^[a-z0-9-]{1,160}$/i.test(handoff.outputId)
    || previousOutputs.length !== 1 || previousOutputs[0] !== handoff.outputId
    || listOutputMentionIds(scope.currentPrompt).length) {
    throw new Error('The previous edit no longer belongs to this request. Select its output again.');
  }
  return `@output:${handoff.outputId} ${scope.currentPrompt}`;
}
